import { FC, useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { actionArr, FilterArr, TableCol } from "./Data";
import { TableLayout } from "Layouts";
import { ControlledTable, Filter2 } from "Components";
import { RouteUrls } from "Constant/RouteUrls";
import { useDispatch, useSelector } from "react-redux";
import { Filter2DataProps } from "DataTypes/Common";
import PatientApi from "Service/Patient.api";
import Formate from "./Formate";
import { clearSelectedPrgm } from "Redux/Patient/Action";
import { InactiveType } from "DataTypes/Services/Patient.type";
import { CheckBoolean, CreateFilter2Payload } from "Utils/common";
import { ScreenInitialStateType } from "DataTypes/Redux";
import UI from "Constant/UI";
import { setPageLimit } from "Redux/Screen/Action";
import CstmBtn from "Components/CstmBtn";

const Inactive: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permission: any = useSelector(
    (state: any) => state?.user?.myPermission?.unresponsivepatient
  );
  const downloadPermission = CheckBoolean(permission?.download);
  const { listPagination }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const reduxLimit = (listPagination || []).find(
    el => el.id == "inactive"
  )?.limit || 10;
  const [pageData, setPageData] = useState({
    ...UI.pageData,
    limit: reduxLimit
  });
  const [rows, setRows] = useState<InactiveType[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [donwloadHeight, setDownloadHeight] = useState<number>(0);
  const [downloading, setDownloading] = useState(false);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(
    JSON.parse(JSON.stringify(FilterArr()))
  );
  const offsetDownload = document?.getElementById("download-id")?.offsetHeight;
  const tableHeight = downloadPermission
    ? `calc(99% - ${filterHeight + donwloadHeight}px)`
    : `calc(99% - ${filterHeight}px)`;

  useEffect(() => {
    dispatch(clearSelectedPrgm());
  }, []);

  useEffect(() => {
    setDownloadHeight(offsetDownload || 0);
  }, [offsetDownload]);

  useEffect(() => {
    handleSetData(1, pageData.limit);
  }, [filterData]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage, currentLimit) => {
    setLoading(true);
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
    };
    const res = await PatientApi.Inactive({
      offset: (currentPage - 1) * currentLimit,
      limit: currentLimit,
      data: payload,
    });
    let newPageData = { ...UI.pageData }
    let newRows: InactiveType[] = [];
    if (res?.success) {
      newRows = Formate.InactiveList(res?.data);
      newPageData = res.criterion
    }
    setRows(newRows);
    setPageData(newPageData)
    dispatch(setPageLimit({ id: "inactive", limit: newPageData.limit }));
    setLoading(false);
  };

  const handlePatientDetails: (data: InactiveType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}/${RouteUrls.details}`
    );
  };

  const handleChart: (data: InactiveType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.clinicalSummary}`
    );
  };

  const handleTask: (data: InactiveType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.task}/${RouteUrls.add}`
    );
  };

  const handleCall: (data: InactiveType) => void = (data) => {
    dispatch(clearSelectedPrgm());
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}/${RouteUrls.callLog}`
    );
  };

  const downloadExport: () => void = async () => {
    setDownloading(true);
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
    };
    const res: any = await PatientApi.DownloadAllInactive({ data: payload });
    if (res?.data) {
      const binaryResponse = res?.data;
      const blob = new Blob([binaryResponse], {
        type: "application/ms-excel",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "inactive_patient_list.xls";
      link.click();
    }
    setDownloading(false);
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol}
      tableRow={rows}
      tableAction={(data: InactiveType) =>
        actionArr(
          () => handleChart(data),
          () => handlePatientDetails(data),
          () => handleTask(data),
          () => handleCall(data),
          data
        )
      }
      searchText={searchText}
    />
  );

  return (
    <Fragment>
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
      />
      {permission?.search && (
        <TableLayout
          tblBody={TblBodyJSX}
          tblHead={ControlledTable.TblHead(TableCol)}
          height={tableHeight}
          loading={loading}
          pageRecordCount={rows.length}
          totalRecordCount={pageData.total}
          Pagination={
            <ControlledTable.Pagination
              mainPage={pageData.page}
              limit={pageData.limit}
              total={pageData.total}
              handleClick={handleSetData}
              tableStyle={true}
            />
          }
        />
      )}
      {downloadPermission && (
        <Box
          id="download-id"
          display={"flex"}
          justifyContent={"flex-end"}
          py={1}
        >
          <CstmBtn
            label={downloading ? "Downloading..." : "Download"}
            onClick={() => downloadExport()}
            disable={downloading}
            width={"10%"}
          />
        </Box>
      )}
    </Fragment>
  );
};
export default Inactive;
